<!-- components/PageHeader.vue -->
<template>
  <div
    class="table-heading mb-0 p-3 d-flex align-items-center justify-content-between"
    :class="customClass"
  >
    <h1 class="title mb-0 fs-20 fw-500">{{ title }}</h1>
    <slot name="actions" />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    customClass: {
      type: [String, Array, Object],
      default: "",
    },
  },
};
</script>
